import { type Fetch } from "../types"

/**
* Encode les url en retirant les points sur les querystring
* qui plantent sur l'infra Akto
* */
export function configEncodeUrlAkto(nextFetch: Fetch): Fetch {
  function encodeDot(url: string, query: string) {
    query = query.split('&')
              .map(token => token.split('='))
              .map(([key, value]) => {
                if (!value || isNaN(parseFloat(value)))
                  return [key, value?.replace('.', '%2E') || '']
                return [key, value]
              })
              .map(keyValue => keyValue.join('='))
              .join('&')
    return `${url}?${query}`
  }

  return async function (input: RequestInfo | URL, init?: RequestInit) {
    if (typeof input === 'string') {
      const [url, query] = input.split('?')
      if (query) {
        input = encodeDot(url!, query)
      }
    } else if (input instanceof Request) {
      const [url, query] = input.url.split('?')
      if (query && url) {
        input = new Request (encodeDot(url, query), input)
      }
    } else if (input instanceof URL) {
      const [url, query] = input.toString().split('?')
      if (query && url) {
        input = new URL(encodeDot(url, query))
      }
    }
    return await nextFetch(input, init)
  }
}
